import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsycho} from "../DjPsycho";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class DjPsychoXBPM extends PIXI.Container implements StageLayer {

    private _xSCharge: TimelineSprite[][] = [];
    private _xSAttention: PIXI.spine.Spine[][] = [];
    private _xSWildTransform: TimelineSprite[][] = [];
    private readonly XS_ATTENTION_ANIMATION_NAMES: string[] = ["X_Bpm_Chicken", "X_Bpm_Hand", "X_Bpm_Skelly"];

    constructor() {
        super();
        this.name = "DjPsychoXBPMView";
        this.init();
    }

    public playAttentionAnimation(reelId: number, symId: number): TimelineLite {
        const animName: string = ArrayHelper.getRandomValue(this.XS_ATTENTION_ANIMATION_NAMES),
            tl: TimelineLite = new TimelineLite(),
            item: PIXI.spine.Spine = this._xSAttention[reelId][symId];

        tl.add([
            () => {
                item.visible = true;
            },
            DjPsycho.createTimelineForAnimation(this._xSAttention[reelId][symId], 0, animName, false)
        ]);
        tl.add(() => {
            item.visible = false;
        });

        return tl;
    }

    public playChargeAnimation(reelId: number, symId: number): TimelineLite {
        return this._xSCharge[reelId][symId].getAnimationAutoShowHide(true, true);
    }

    public playWildAnimation(reelId: number, symId: number): TimelineLite {
        return this._xSWildTransform[reelId][symId].getAnimationAutoShowHide(true, true);
    }

    private init(): void {
        let xSCharge: TimelineSprite,
            xSAttention: PIXI.spine.Spine,
            xSWildTransform: TimelineSprite;

        for (let reel: number = 0; reel < DjPsycho.reelsNum; reel++) {
            this._xSCharge.push([]);
            this._xSAttention.push([]);
            this._xSWildTransform.push([]);
            for (let row: number = 0; row < DjPsycho.rowsNum; row++) {
                xSCharge = new TimelineSprite(DjPsycho.assetLoader.getTextures("FX_X_Charge/X_Charge_"));
                xSCharge.hide();
                xSCharge.anchor.set(0.5);
                xSCharge.blendMode = PIXI.BLEND_MODES.ADD;
                xSCharge.position.set((DjPsycho.reelViewX + (reel * DjPsycho.symbolWidth) + DjPsycho.symbolWidth / 2 + (reel * DjPsycho.padding)), (DjPsycho.reelViewY + (row * DjPsycho.symbolHeight) + (row * DjPsycho.padding)));

                xSAttention = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("xBPM"));
                xSAttention.visible = false;
                xSAttention.position = xSCharge.position;

                xSWildTransform = new TimelineSprite(DjPsycho.assetLoader.getTextures("Xs_Wild_Transform/Xs_Wild_Transform_"));
                xSWildTransform.hide();
                xSWildTransform.anchor.set(0.5);
                xSWildTransform.scale.set(2);
                xSWildTransform.position = xSCharge.position;

                this._xSCharge[reel].push(xSCharge);
                this._xSAttention[reel].push(xSAttention);
                this._xSWildTransform[reel].push(xSWildTransform);

                this.addChild(xSCharge, xSWildTransform);
            }
        }

        // making sure attention is always on top from it's right side neighbours.
        this._xSAttention.forEach((items: PIXI.spine.Spine[]) => {
            items.forEach((item: PIXI.spine.Spine) => {
                this.addChild(item);
            });
        });
    }
}